import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { getPaymentHistory } from "../../Thunks/SiteMenuThunks";
import { SubscriptionHistory } from "../../Types/SiteMenuModel/MySubscription/SubscriptionHistory";
interface PaymentHistorySliceState {
    loader: boolean; // for refres pages and inital loadings
    paymentHistory: SubscriptionHistory[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : PaymentHistorySliceState = {
    loader: false,
    paymentHistory: [],
    errorDisplay: '',

}

// set state valu for api response
const paymentHistorySlice = createSlice ({
    name: 'paymentHistory',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getPaymentHistory.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getPaymentHistory.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getPaymentHistory.fulfilled, (state, action: PayloadAction<SubscriptionHistory[]>) => {
                    state.loader = false;
                    state.paymentHistory = action.payload;
                  })
    }
})

export const {} = paymentHistorySlice.actions
export default paymentHistorySlice.reducer
